// ResetPassSuccessController
app.controller('ResetPassSuccessController', ['$scope', 'sessionService',
    function($scope, sessionService) {

        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            $scope.userfullname = sessionService.get("username");
        };
    }
]);